import {
  ApprovalType,
  LeaveRequest,
  LeaveRequestDTO,
} from "@/models/leave-requests.model";
import React, { useEffect } from "react";
import { MdOutlinePendingActions } from "react-icons/md";
import { IoMdDoneAll } from "react-icons/io";
import { CgUnavailable } from "react-icons/cg";
import StatisticsCard from "@/components/dashboard/StatisticsCard";
import { useAppDispatch, useAppSelector } from "@/app/hooks";
import { fetchAllLeaveRequestsCount } from "@/features/leaveRequests/leaveRequestSlice";

function Statistics() {
  const dispatch = useAppDispatch();
  const { adminCounts } = useAppSelector((state) => state.leaveRequests);

  useEffect(() => {
    dispatch(fetchAllLeaveRequestsCount());
  }, [dispatch]);

  return (
    <div className="flex w-full sm:h-[100px] h-[130px] justify-between items-center sm:gap-5 gap-2 ">
      <StatisticsCard
        statValue={
          adminCounts?.[ApprovalType.PENDING] || 0
        }
        statTitle="Pending Approval"
        statIcon={<MdOutlinePendingActions color="#fb923c" className="min-w-5 min-h-5" />}
        statIconBgColor="bg-orange-100"
      />
      <StatisticsCard
        statValue={
          adminCounts?.[ApprovalType.APPROVED] || 0
        }
        statTitle="Requests Approved"
        statIcon={<IoMdDoneAll color="#34d399" className="min-w-5 min-h-5" />}
        statIconBgColor="bg-green-100"
      />
      <StatisticsCard
        statValue={
          adminCounts?.[ApprovalType.REJECTED] || 0
        }
        statTitle="Requests Rejected"
        statIcon={<CgUnavailable color="#f87171" className="min-w-5 min-h-5" />}
        statIconBgColor="bg-red-100"
      />
      {/* icon in -400 */}
    </div>
  );
}

export default Statistics;
